
<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>

        <div class="table-listings">
            <el-table
                :data="channels"
                style="width: 100%"
            >
                <el-table-column
                    prop="id"
                    label="#"
                    width="50"
                />

                <el-table-column
                    prop="assign"
                    label=""
                />

                <el-table-column label="">
                    <template slot-scope="scope">
                        <button class="btn-sm border-0 shadow-none"
                            :class="flags[scope.row.assign] ? 'btn-success' : 'btn-secondary'"
                            @click="toggleFlag(scope.row.assign)">
                            <h5 class="m-0">
                                <b-icon icon="hand-thumbs-up-fill" 
                                    :class="flags[scope.row.assign] ? 'text-white' : ''"
                                ></b-icon>
                            </h5>
                        </button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </b-card>
</template>

<script>
import { Table, TableColumn, Button } from 'element-ui'
import useCustomerAssignmentStore from "@/stores/customerAssignmentStore";

export default {
  name: "ChannelTable",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button
  },
  data() {
    return {
      channels: [
        { id: 1, assign: "TM" },
        { id: 2, assign: "Advisor" },
        { id: 3, assign: "Support" },
      ],
      flags: {}
    };
  },

  computed: {
    store() {
      return useCustomerAssignmentStore();
    },
  },

  mounted() {
    this.flags = {
      TM: this.store.fTM,
      Advisor: this.store.fAdvisor,
      Support: this.store.fSupport,
    };
  },

  methods: {
    toggleFlag(assign) {
      this.flags[assign] = !this.flags[assign];
    },
    getFlags() {
      return { ...this.flags };
    }
  }
};
</script>